import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Home = () => {
  return (
    <Wrapper>
      <h3>Please select one of the following</h3>
      <a href="https://www.wheretoshoot.org/list-your-range" className="button">
        List your range for the first time
      </a>
      <Link to="/edit-range/find-range" className="button">
        Edit an existing range listing
      </Link>
    </Wrapper>
  );
};

export default Home;

const Wrapper = styled.div`
  text-align: center;
  margin: auto;

  h4 {
    margin-bottom: 20px;
  }

  a {
    margin: 20px;
  }
`;
